import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute, useAuth } from "@/lib/auth";
import Dashboard from "@/pages/Dashboard";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdminPage from "@/pages/AdminPage";
import SuspendedScreen from "@/pages/SuspendedScreen";
import { ChangePasswordModal } from "@/components/modals/ChangePasswordModal";
import React from "react";
import axios from "axios";

axios.defaults.withCredentials = true;

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#f7f6f4", color: "#18181b", fontFamily: "Manrope, sans-serif" }}>
          <p style={{ fontSize: 18, marginBottom: 16 }}>Algo deu errado.</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }} style={{ padding: "8px 24px", background: "#1b4332", color: "#ffffff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: 600 }}>Recarregar</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function HomeRouter() {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen flex items-center justify-center bg-[#f7f6f4] text-[#71717a] text-sm">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <AppWithPasswordModal />;
  if (user.is_admin) return <Navigate to="/admin" replace />;
  if (user.status === "vencido" || user.status === "bloqueado") return <SuspendedScreen status={user.status} />;
  return <Dashboard />;
}

function AdminGate() {
  const { user } = useAuth();
  if (user?.must_change_password) return <AppWithPasswordModal />;
  return <AdminPage />;
}

function AppWithPasswordModal() {
  return (
    <>
      <ChangePasswordModal open forced />
      <div className="min-h-screen bg-[#f7f6f4]" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/registrar" element={<RegisterPage />} />
              <Route path="/admin" element={<ProtectedRoute><AdminGate /></ProtectedRoute>} />
              <Route path="/" element={<HomeRouter />} />
            </Routes>
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
